import React from "react";
import { XMarkIcon } from "@heroicons/react/24/outline";

import Button from "../../components/atomic/Button";

type Props = {
  name: string;
  onClose: () => void;
};

export default function Title({ name, onClose }: Props) {
  return (
    <div className="flex items-center justify-between">
      <div className="text-[#343F59] text-2xl font-medium">{name}</div>
      <Button onClick={onClose} className="!p-2 bg-[#FAFAFA]">
        <XMarkIcon className="h-5 w-5 text-[#4C4C4D]" />
      </Button>
    </div>
  );
}
